import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-msg"
}

import { IMonthYear } from '@/types';
import { ref, watch, onMounted } from 'vue';

interface IProps {
  modelValue?: any;
  msgError?: string;
  classes?: string;
  label?: string;
  prependIcon?: boolean;
  required?: boolean;
  width?: string;
  noBgPrependIcon?: boolean;
  noBorderPrependIcon?: boolean;
  hasError?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomMonthPicker',
  props: {
    modelValue: null,
    msgError: null,
    classes: null,
    label: null,
    prependIcon: { type: Boolean },
    required: { type: Boolean },
    width: null,
    noBgPrependIcon: { type: Boolean },
    noBorderPrependIcon: { type: Boolean },
    hasError: { type: Boolean }
  },
  emits: ["update:modelValue", "clean"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: IMonthYear | undefined): void;
  (e: 'clean');
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue?: any;
  msgError?: string;
  classes?: string;
  label?: string;
  prependIcon?: boolean;
  required?: boolean;
  width?: string;
  noBgPrependIcon?: boolean;
  noBorderPrependIcon?: boolean;
  hasError?: boolean;
};



const month = ref<IMonthYear>();


watch(
  () => month.value,
  () => {
    emit('update:modelValue', month.value);
  }
);
onMounted(() => {
  month.value = props.modelValue;
});

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["input-wapper d-flex ms-3", { error: __props.hasError }]),
      style: {"width":"150px"}
    }, [
      (__props.prependIcon)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([{ 'bg-gray-06': !__props.noBgPrependIcon, 'border-e': !__props.noBorderPrependIcon, error: __props.hasError }, "prependIcon h-100 px-2 d-flex align-center"])
          }, [
            _renderSlot(_ctx.$slots, "prependIcon")
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_VueDatePicker, {
        locale: "pt-BR",
        modelValue: month.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((month).value = $event)),
        onCleared: _cache[1] || (_cache[1] = ($event: any) => (emit('clean'))),
        "month-picker": "",
        "first-day-of-week": 1
      }, null, 8, ["modelValue"])
    ], 2),
    (__props.hasError && __props.msgError)
      ? (_openBlock(), _createElementBlock("small", _hoisted_1, _toDisplayString(__props.msgError), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})